import './App.css';
import PanoramaViewer from "./components/PanoramaViewer";

function App() {
  return (
     <PanoramaViewer/>
  );
}

export default App;
